module.exports = __webpack_public_path__ + "static/media/city_driver.9dceefde.svg";